import api from './api';

const threadService = {
  async getThread(slug, options = {}) {
    const response = await api.get(`/api/threads/${slug}`, {
      params: {
        page: options.page,
        limit: options.limit,
      },
    });
    return response.data;
  },

  async createThread(threadData) {
    const response = await api.post('/api/threads', threadData);
    return response.data;
  },

  async updateThread(id, threadData) {
    const response = await api.put(`/api/threads/${id}`, threadData);
    return response.data;
  },

  async updateModeration(id, moderationData) {
    const response = await api.patch(`/api/threads/${id}/moderation`, moderationData);
    return response.data;
  },

  async updateRpStatus(id, rpStatus) {
    const response = await api.patch(`/api/threads/${id}/rp-status`, { rpStatus });
    return response.data;
  },

  async updateThreadTheme(id, threadTheme) {
    const response = await api.patch(`/api/threads/${id}/theme`, { threadTheme });
    return response.data;
  },

  async deleteThread(id) {
    const response = await api.delete(`/api/threads/${id}`);
    return response.data;
  },

  async getModerationLogs(id, options = {}) {
    const response = await api.get(`/api/threads/${id}/moderation-logs`, {
      params: {
        page: options.page,
        limit: options.limit,
      },
    });
    return response.data;
  },
};

export default threadService;

